/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/* tslint:disable:no-string-literal */

import { FieldAttributes } from '@support/shared/models/field-validation-field-attribute.model';
import { ErrorMessage } from '@support/shared/models/field-validation-error-message.model';

/**
 * Model to store field validation attributes for specific keys
 */
export class FieldValidationItem {
  public allowedChars?: string;
  public id: string;
  public placeholder?: string;
  public regex?: string;
  public required?: boolean;
  public errorMessages?: ErrorMessage;
  public fieldAttributes: FieldAttributes;

  /**
   * Extracts field attributes from model if the field exists in JSON
   */
  constructor(fieldValidationItem: object) {
    if (fieldValidationItem['fieldValidationItem']) {
      this.id = fieldValidationItem['fieldValidationItem'] || 'INVALID';
    }
    if (fieldValidationItem['placeholder']) {
      this.placeholder = fieldValidationItem['placeholder'];
    }
    if (fieldValidationItem['regex']) {
      this.regex = fieldValidationItem['regex'];
    }
    if (fieldValidationItem['required']) {
      this.required = fieldValidationItem['required'];
    }
    if (fieldValidationItem['errorMessages']) {
      this.errorMessages = fieldValidationItem['errorMessages'];
    }
    if (fieldValidationItem['fieldAttributes']) {
      this.fieldAttributes = fieldValidationItem['fieldAttributes'];
    }
    if (fieldValidationItem['allowedChars']) {
      this.allowedChars = fieldValidationItem['allowedChars'];
    }
  }
}
